module.exports = __webpack_public_path__ + "img/libyan_labs_logo_dark_bg_withtext.718d3943.png";